export const LANGFUSE_SYSTEM_TAG = 'system';
export const LANGFUSE_PROMPT_TAG = 'prompt';

export const LANGFUSE_PRODUCTION_LABEL = 'production';
export const LANGFUSE_LATEST_LABEL = 'latest';

export const SYSTEM_PROMPT_ANONYMIZED_CONSIDERATIONS = 'SYSTEM_anonymized_considerations';
export const SYSTEM_PROMPT_CHANGE_LANGUAGE = 'SYSTEM_change_language';
export const SYSTEM_PROMPT_DETAILED_REPORT_INSTRUCTIONS = 'SYSTEM_detailed_report_instructions';
export const SYSTEM_PROMPT_SUGGESTED_PROMPTS = 'SYSTEM_suggested_prompt';

